import React, { useState, useContext } from "react";
import { AiFillCloseCircle } from "react-icons/ai";
import { AlertContext, UserContext } from "../context/MainContext";
import { HOST } from "../constants/HostConstants";

const ReportModal = ({ isOpen, onClose }) => {
  const [message, setMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { setAlert } = useContext(AlertContext);
  const { user } = useContext(UserContext);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!message.trim()) {
      setAlert(["Error", "Please enter a message", "failed"]);
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await fetch(`${HOST}/api/user/reportIssue`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          message: message.trim(),
          userEmail: user?.email_address || "Anonymous",
          userName: user
            ? `${user.legal_first_name} ${user.legal_last_name}`
            : "Anonymous User",
          userId: user?.user_id || null,
          timestamp: new Date().toISOString(),
          url: window.location.href,
        }),
      });

      if (response.ok) {
        setAlert(["Success", "Thank you for your feedback!", "confirm"]);
        setMessage("");
        onClose();
      } else {
        setAlert([
          "Error",
          "Failed to submit report. Please try again.",
          "failed",
        ]);
      }
    } catch (error) {
setAlert([
        "Error",
        "Failed to submit report. Please try again.",
        "failed",
      ]);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <>
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-[70]"
        onClick={onClose}
      ></div>
      <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[71] w-full max-w-lg px-4">
        <div className="bg-white rounded-lg shadow-2xl p-6 relative">
          <button
            onClick={onClose}
            className="absolute right-4 top-4 hover:scale-110 transition-all"
          >
            <AiFillCloseCircle size={30} className="text-gray-600" />
          </button>

          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            Report Issue / Suggestion
          </h2>
          <p className="text-sm text-gray-600 mb-4">
            Help us improve myLlave by reporting bugs or suggesting improvements
          </p>

          <form onSubmit={handleSubmit}>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Describe the issue or suggestion..."
              className="w-full h-40 p-4 border-2 border-gray-300 rounded-lg resize-none focus:outline-none focus:border-yellow-500 transition-colors"
              disabled={isSubmitting}
            />

            <div className="flex gap-3 mt-4">
              <button
                type="button"
                onClick={onClose}
                className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-800 px-4 py-3 rounded-lg font-semibold transition-all"
                disabled={isSubmitting}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="flex-1 bg-yellow-500 hover:bg-yellow-600 text-white px-4 py-3 rounded-lg font-semibold transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit Report"}
              </button>
            </div>
          </form>

          {user && (
            <p className="text-xs text-gray-500 mt-3">
              Submitting as: {user.legal_first_name} {user.legal_last_name} (
              {user.email_address})
            </p>
          )}
        </div>
      </div>
    </>
  );
};

export default ReportModal;
